export default __webpack_public_path__ + "static/media/credBack.91df1eff.png";